(function(){
  if(window.RepairProcessNotchLoaded)return;
  window.RepairProcessNotchLoaded=true;

  function setInternationalState(value){
    document.querySelectorAll('[data-international-only]').forEach(function(item){item.hidden=value!=='international';});
  }

  function initInternational(root){
    root.querySelectorAll('[data-international-block]').forEach(function(block){
      var domestic=block.querySelector('[data-domestic-panel]');
      var international=block.querySelector('[data-international-panel]');
      block.querySelectorAll('input[type="radio"]').forEach(function(radio){
        radio.addEventListener('change',function(){
          domestic.hidden=radio.value!=='domestic';
          international.hidden=radio.value!=='international';
          setInternationalState(radio.value);
        });
      });
    });
  }

  function fillSheet(container,form,blank){
    container.querySelectorAll('[data-print-value]').forEach(function(output){
      var field=form.elements.namedItem(output.getAttribute('data-print-value'));
      output.textContent=blank?'':(field&&field.value?field.value:'N/A');
    });
  }

  function beginPrint(container){
    var sheet=container.querySelector('[data-print-sheet]');
    var printWindow=window.open('','_blank','width=900,height=700');
    if(!printWindow){
      window.alert('Please allow pop-ups for this website, then try printing again.');
      return;
    }
    printWindow.document.open();
    printWindow.document.write('<!doctype html><html><head><meta charset="utf-8"><title>Repair Request</title><style>@page{margin:.55in}*{box-sizing:border-box}body{color:#111;font-family:Arial,sans-serif;font-size:12pt;line-height:1.35;margin:0}.repair-request-notch__sheet{margin:0 auto;max-width:7.4in}.repair-request-notch__sheet h2{border-bottom:2px solid #0155a2;color:#0155a2;font-size:22pt;margin:0 0 20px;padding-bottom:10px;text-align:center}.repair-request-notch__sheet dl{margin:0}.repair-request-notch__sheet dl div{break-inside:avoid;display:grid;grid-template-columns:2.15in minmax(0,1fr);padding:6px 0}.repair-request-notch__sheet dt{font-weight:700}.repair-request-notch__sheet dd{margin:0;min-height:1.35em;overflow-wrap:anywhere;white-space:pre-wrap}@media(max-width:600px){.repair-request-notch__sheet dl div{grid-template-columns:1fr}.repair-request-notch__sheet dd{border-bottom:1px solid #ccc;padding:3px 0 7px}}</style></head><body>'+sheet.outerHTML+'</body></html>');
    printWindow.document.close();
    printWindow.focus();
    window.setTimeout(function(){printWindow.print();},250);
  }

  function endPrint(){
    document.body.classList.remove('repair-request-printing');
    document.querySelectorAll('[data-repair-form].is-print-target').forEach(function(item){item.classList.remove('is-print-target');});
  }

  function initForms(root){
    root.querySelectorAll('[data-repair-form]').forEach(function(container){
      var form=container.querySelector('form');
      var preview=container.querySelector('[data-form-preview]');
      form.addEventListener('submit',function(event){
        event.preventDefault();
        if(!form.reportValidity())return;
        fillSheet(container,form,false);
        preview.hidden=false;
        preview.scrollIntoView({behavior:'smooth',block:'start'});
      });
      container.querySelector('[data-print-filled]').addEventListener('click',function(){fillSheet(container,form,false);beginPrint(container);});
      container.querySelector('[data-print-blank]').addEventListener('click',function(){fillSheet(container,form,true);preview.hidden=false;beginPrint(container);});
    });
  }

  function init(root){initInternational(root);initForms(root);}
  function boot(){init(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  window.addEventListener('afterprint',endPrint);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
